import { ICarga } from '../../interfaces';

export const carga: Record<string, ICarga> = {
    '5903': {
        pedidos: ['162428886'],
        pedidosOrdenados: ['162428886'],
        summary: {
            travelTime: 5703,
            distance: 88849,
        },
    },
    '15777': {
        pedidos: [
            '162428925',
            '162428911',
            '162428882',
            '162428908',
            '162428918',
            '162428902',
            '162428899',
            '162428854',
        ],
        pedidosOrdenados: [
            '162428925',
            '162428911',
            '162428882',
            '162428908',
            '162428918',
            '162428902',
            '162428899',
            '162428854',
        ],
        summary: {
            travelTime: 29880,
            distance: 76273,
        },
    },
    '116066': {
        pedidos: [
            '162428843',
            '162428846',
            '162428900',
            '162428847',
            '162428901',
            '162428850',
            '162428856',
            '162428853',
            '162428934',
            '162428873',
            '162428917',
            '162428897',
            '162428895',
            '162428887',
            '162428896',
            '162428893',
            '162428890',
            '162428885',
            '162428916',
            '162428906',
            '162428888',
            '162428903',
            '162428881',
            '162428879',
            '162428876',
            '162428860',
            '162428910',
            '162428851',
            '162428878',
            '162428884',
            '162428922',
        ],
        pedidosOrdenados: [
            '162428843',
            '162428846',
            '162428900',
            '162428847',
            '162428901',
            '162428850',
            '162428856',
            '162428853',
            '162428934',
            '162428873',
            '162428917',
            '162428897',
            '162428895',
            '162428887',
            '162428896',
            '162428893',
            '162428890',
            '162428885',
            '162428916',
            '162428906',
            '162428888',
            '162428903',
            '162428881',
            '162428879',
            '162428876',
            '162428860',
            '162428910',
            '162428851',
            '162428878',
            '162428884',
            '162428922',
        ],
        summary: {
            travelTime: 34886,
            distance: 55427,
        },
    },
    '117096': {
        pedidos: [
            '162428898',
            '162428864',
            '162428912',
            '162428931',
            '162428891',
            '162428869',
            '162428865',
            '162428936',
            '162428924',
            '162428921',
            '162428909',
            '162428863',
            '162428927',
        ],
        pedidosOrdenados: [
            '162428898',
            '162428864',
            '162428912',
            '162428931',
            '162428891',
            '162428869',
            '162428865',
            '162428936',
            '162428924',
            '162428921',
            '162428909',
            '162428863',
            '162428927',
        ],
        summary: {
            travelTime: 55036,
            distance: 750381,
        },
    },
    '117106': {
        pedidos: [
            '162428858',
            '162428915',
            '162428855',
            '162428862',
            '162428868',
            '162428932',
            '162428870',
            '162428937',
            '162428892',
            '162428883',
            '162428889',
            '162428938',
            '162428928',
            '162428867',
            '162428929',
            '162428852',
            '162428914',
            '162428880',
            '162428842',
            '162428905',
            '162428872',
            '162428933',
            '162428875',
            '162428877',
            '162428926',
            '162428857',
            '162428849',
            '162428848',
            '162428845',
            '162428920',
            '162428939',
            '162428907',
            '162428923',
            '162428861',
            '162428904',
        ],
        pedidosOrdenados: [
            '162428858',
            '162428915',
            '162428855',
            '162428862',
            '162428868',
            '162428932',
            '162428870',
            '162428937',
            '162428892',
            '162428883',
            '162428889',
            '162428938',
            '162428928',
            '162428867',
            '162428929',
            '162428852',
            '162428914',
            '162428880',
            '162428842',
            '162428905',
            '162428872',
            '162428933',
            '162428875',
            '162428877',
            '162428926',
            '162428857',
            '162428849',
            '162428848',
            '162428845',
            '162428920',
            '162428939',
            '162428907',
            '162428923',
            '162428861',
            '162428904',
        ],
        summary: {
            travelTime: 38741,
            distance: 199360,
        },
    },
    '117112': {
        pedidos: ['162428844', '162428859', '162428871', '162428935', '162428874'],
        pedidosOrdenados: ['162428844', '162428859', '162428871', '162428935', '162428874'],
        summary: {
            travelTime: 12889,
            distance: 43301,
        },
    },
    '117115': {
        pedidos: ['162428919', '162428913', '162428866', '162428930', '162428894'],
        pedidosOrdenados: ['162428919', '162428913', '162428866', '162428930', '162428894'],
        summary: {
            travelTime: 25219,
            distance: 611689,
        },
    },
};
